<template>
    <div class="dashboard-header-page">
        <div class="dashboard-title">
            <i
                v-if="icon"
                class="mr-2"
                :class="icon"
            ></i>
            {{ title }}
        </div>
        <div
            class="dashboard-subtitle"
            v-if="subTitle"
        >
            {{ subTitle }}
        </div>
    </div>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        subTitle: {
            type: String,
            default: null
        },
    }
}

</script>

<style scoped>
.dashboard-header-page {
    background: linear-gradient(135deg, #f8981d 0%, #fd7e14 100%);
    border-radius: 12px;
    padding: 2rem;
    color: white;
    margin-bottom: 2rem;
    box-shadow: 0 4px 15px rgba(248, 152, 29, 0.2);
}

.dashboard-title {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
}

.dashboard-subtitle {
    font-size: 1.1rem;
    opacity: 0.9;
    margin-bottom: 0;
}

@media (max-width: 768px) {
       .dashboard-header-page {
        padding: 1.5rem;
        text-align: center;
    }

    .dashboard-title {
        font-size: 1.5rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Base/PageHeader.vue